import { getProjects, stripHtml, type Project } from "./projects";
import { getProjectUrl } from "./portfolioRoutes";
import { toCardImage } from "./cardImage";

export type WatchVideo = {
  id: string;
  projectId: string;
  youtubeId: string;
  title: string;
  description: string;
  thumbnail: string;
  uploadDate: string;
  projectUrl: string;
  embedHtml: string;
};

const YT_EMBED =
  /(?:youtube\.com\/embed\/|youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{6,})/i;

export function extractYoutubeId(embedOrUrl: string): string | null {
  const m = embedOrUrl.match(YT_EMBED);
  return m?.[1] ?? null;
}

function toWatchVideo(project: Project): WatchVideo | null {
  if (!project.video?.trim()) return null;
  const youtubeId = extractYoutubeId(project.video);
  if (!youtubeId) return null;
  return {
    id: project.id,
    projectId: project.id,
    youtubeId,
    title: stripHtml(project.title),
    description: stripHtml(project.description).slice(0, 300),
    thumbnail: toCardImage(project.hero || project.image),
    uploadDate: project.date.toISOString().slice(0, 10),
    projectUrl: getProjectUrl(project),
    embedHtml: project.video,
  };
}

export function getWatchVideos(): WatchVideo[] {
  return getProjects()
    .map(toWatchVideo)
    .filter((v): v is WatchVideo => Boolean(v));
}

export function getWatchVideo(id: string): WatchVideo | undefined {
  return getWatchVideos().find((v) => v.id === id);
}

export function getWatchPath(id: string): string {
  return `/watch/${id}`;
}
